import { useState, useCallback } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/** Hook minimal pour remplacer window.confirm avec un dialog Shadcn.
 *  Usage : const confirm = useConfirm(); ... if (await confirm("Supprimer ?")) ...
 */
export function useConfirm() {
  const [state, setState] = useState({ open: false, title: "", description: "", confirmLabel: "Confirmer", tone: "default", resolve: null });

  const confirm = useCallback(
    (opts) => {
      const o = typeof opts === "string" ? { description: opts } : opts || {};
      return new Promise((resolve) => {
        setState({
          open: true,
          title: o.title || "Êtes-vous sûr ?",
          description: o.description || "",
          confirmLabel: o.confirmLabel || "Confirmer",
          cancelLabel: o.cancelLabel || "Annuler",
          tone: o.tone || "default",
          resolve,
        });
      });
    },
    []
  );

  const close = (val) => {
    if (state.resolve) state.resolve(val);
    setState((s) => ({ ...s, open: false, resolve: null }));
  };

  const dialog = (
    <AlertDialog open={state.open} onOpenChange={(o) => !o && close(false)}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{state.title}</AlertDialogTitle>
          {state.description && (
            <AlertDialogDescription>{state.description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)} data-testid="confirm-cancel">
            {state.cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => close(true)}
            data-testid="confirm-ok"
            className={state.tone === "danger" ? "bg-[color:var(--cf-danger)] hover:bg-[color:var(--cf-danger)]" : ""}
          >
            {state.confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { confirm, dialog };
}
